module.exports = __webpack_public_path__ + "static/media/business.2400536d.png";